export const authChannel = new BroadcastChannel("auth_channel");